// Docs: https://connectrpc.com/docs/introduction

// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file common/v1/common.proto (package common.v1, syntax proto3)
/* eslint-disable */

import type { GenExtension, GenFile } from "@bufbuild/protobuf/codegenv2";
import { extDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";
import type { FieldOptions } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_descriptor } from "@bufbuild/protobuf/wkt";

/**
 * Describes the file common/v1/common.proto.
 */
export const file_common_v1_common: GenFile = /*@__PURE__*/
  fileDesc("ChZjb21tb24vdjEvY29tbW9uLnByb3RvEgljb21tb24udjE6OgoIZmllbGRfaWQSHS5nb29nbGUucHJvdG9idWYuRmllbGRPcHRpb25zGNOGAyABKAlSB2ZpZWxkSWRCP1o9Z2l0aHViLmNvbS91bmlwaG9yZS9zdW5zdG9uZS9wa2cvZ28vZ2VuL3BiL2NvbW1vbi92MTtjb21tb25WMWIGcHJvdG8z", [file_google_protobuf_descriptor]);

/**
 * The field_id is a string identifier for the field, used for additional type safety
 *
 * @generated from extension: string field_id = 50003;
 */
export const field_id: GenExtension<FieldOptions, string> = /*@__PURE__*/
  extDesc(file_common_v1_common, 0);

